
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/analytics-roi",
      function () {
        return require("private-next-pages/docs/analytics-roi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/analytics-roi"])
      });
    }
  